import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import GameGrid from './components/GameGrid';
import GamePage from './components/GamePage';
import { GameSelectScreen } from './components/kjorMin/GameSelectScreen';
import { LevelSelectScreen } from './components/kjorMin/LevelSelectScreen';
import { LevelPlayPage } from './components/kjorMin/LevelPlayPage';
import { StickerBookPage } from './features/stickerBook/StickerBookPage';
import { SHOW_LEGACY_GAMES } from './config/featureFlags';
import { FirstRunAgeScreen } from './features/profile/AgePicker';
import { ParentSettingsPage } from './features/profile/ParentSettingsPage';
import { GarageScreen } from './features/profile/GarageScreen';
import { useProfileStore } from './store/profile';

/** Until a parent has picked the child's age, every route shows the age picker. */
const ProfileGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const profile = useProfileStore((s) => s.profile);
  const setAgeBand = useProfileStore((s) => s.setAgeBand);
  if (!profile) return <FirstRunAgeScreen onPick={setAgeBand} />;
  return <>{children}</>;
};

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gradient-to-b from-primary to-secondary">
        <ProfileGate>
        <Routes>
          <Route path="/" element={<GameSelectScreen />} />
          <Route path="/foreldre" element={<ParentSettingsPage />} />
          <Route path="/garasje" element={<GarageScreen />} />
          <Route path="/klistremerker" element={<StickerBookPage />} />
          <Route path="/spill/:gameId" element={<LevelSelectScreen />} />
          <Route path="/spill/:gameId/:levelId" element={<LevelPlayPage />} />

          {/* Legacy sandbox games — hidden unless REACT_APP_SHOW_LEGACY_GAMES=true */}
          {SHOW_LEGACY_GAMES ? (
            <>
              <Route path="/legacy" element={<GameGrid />} />
              <Route path="/drive-my-bus" element={<GamePage gameId="bus" />} />
              <Route path="/drive-my-tractor" element={<GamePage gameId="tractor" />} />
              <Route path="/drive-my-plane" element={<GamePage gameId="plane" />} />
              <Route path="/drive-my-monster-truck" element={<GamePage gameId="monstertruck" />} />
              <Route path="/drive-my-pickup-truck" element={<GamePage gameId="pickuptruck" />} />
              <Route path="/drive-my-police-car" element={<GamePage gameId="policecar" />} />
              <Route path="/drive-my-firetruck" element={<GamePage gameId="firetruck" />} />
              <Route path="/drive-my-ambulance" element={<GamePage gameId="ambulance" />} />
              <Route path="/drive-my-garbage-truck" element={<GamePage gameId="garbagetruck" />} />
              <Route path="/drive-my-bulldozer" element={<GamePage gameId="bulldozer" />} />
              <Route path="/drive-my-roadroller" element={<GamePage gameId="roadroller" />} />
              <Route path="/drive-my-excavator" element={<GamePage gameId="excavator" />} />
              <Route path="/drive-my-tank" element={<GamePage gameId="tank" />} />
            </>
          ) : null}
        </Routes>
        </ProfileGate>
      </div>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
